module.exports = __webpack_public_path__ + "mobile/img/show-banner.9e852c9b.png";